import { mapEnumToOptions } from '@abp/ng.core';

export enum ProfileVisibility {
  Public = 0,
  Private = 1,
}

export const profileVisibilityOptions = mapEnumToOptions(ProfileVisibility);
